<template>
    <b-modal
        centered
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        v-model="formCategory.isShow"
    >
        <template #modal-header="{}">
            <div class="header flex-grow-1 text-center">
                <h2 class="font-weight-bold">เพิ่มหมวดหมู่เส้นทาง</h2>
                <small>กรอกชื่อหมวดหมู่ที่ต้องการเพิ่มในรายการ</small>
            </div>
            <span class="close cursor-pointer" @click="formCategory.isShow = false">&times;</span>
        </template>
        <card shadow type="secondary" class="m--4">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="ชื่อหมวดหมู่เส้นทาง">
                        <b-form-input
                            placeholder="ระบุชื่อหมวดหมู่"
                            v-model="categoryName"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <template slot="footer">
                <b-row class="justify-content-between">
                    <b-col cols="4">
                        <b-button
                            block
                            @click="closeModalConfirm()"
                        >
                            ยกเลิก
                        </b-button>
                    </b-col>
                    <b-col cols="4">
                        <b-button 
                            type="submit" 
                            variant="primary"
                            block
                            :disabled="form.isLoad"
                            @click="addCategoryRoute()"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="formCategory.isLoad"></i> 
                            ยืนยัน
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </card>
    </b-modal>
</template>
<script>

export default {
    components: {},
    props: {
        form: {
            type: Object
        },
        formCategory: {
            type: Object
        }
    },
    data(){
        return {
            categoryName: null
        }
    },
    methods: {
        addCategoryRoute(){
            console.log(this.categoryName,  'this.categoryName, ' )
            this.form.categoryRoutes.push({
                name: this.categoryName, 
                routes: [{ name: "", url: "" }]
            });

            this.closeModalConfirm();
        },
        closeModalConfirm(){
            this.categoryName = null
            this.formCategory.isShow = false
            this.formCategory.isLoad = false
        }
    }
}
</script>
